import React from 'react';
import { Interp, css, toList } from '../../lib/render.jsx';
import { Kruis } from '../Iconen.jsx';

export default function DmCompose({ v }) {
  if (!v.showDmCompose) return null;
  return (
    <>
      {' '}
      <div className="gp-laag" style={{ "position": "fixed", "inset": "0", "background": "rgba(36,27,58,.7)", "display": "flex", "alignItems": "center", "justifyContent": "center", "zIndex": "98", "padding": "20px" }} onClick={v.closeDm}>
        <div className="gp-venster" style={{ "width": "min(440px,100%)", "padding": "24px", "display": "flex", "flexDirection": "column", "gap": "14px" }} onClick={v.stopProp}>
          <div style={{ "display": "flex", "alignItems": "center", "gap": "10px" }}>
            <div style={{ "fontSize": "19px", "fontWeight": "700", "flex": "1 1 auto" }}>
              Persoonlijk bericht
            </div>
            <button onClick={v.closeDm} title="Sluiten" style={css(v.sluitStyle)}>
              <Kruis maat={20} />
            </button>
          </div>
          {v.dmPicking ? (<>
            <div style={{ "fontSize": "13px", "fontWeight": "600", "color": "var(--tekst-2)" }}>
              Naar wie stuur je een bericht?
            </div>
            {v.showBroadcastPick ? (<>
              <button onClick={v.openBroadcast} className="gp-btn pink" style={css(v.hoofdKnopStyle)}>
                <span style={{ "fontSize": "19px" }}>
                  📣
                </span>
                <span style={{ "fontSize": "14px", "fontWeight": "700", "flex": "1 1 auto", "textAlign": "left" }}>
                  <Interp v={v.broadcastLabel} />
                </span>
              </button>
            </>) : null}
            <div style={{ "display": "grid", "gridTemplateColumns": "repeat(auto-fill,minmax(44px,1fr))", "alignItems": "start", "justifyItems": "stretch", "gap": "10px", "width": "100%", "boxSizing": "border-box", "maxHeight": "300px", "overflowY": "auto", "overflowX": "hidden", "padding": "2px 5px 6px 2px" }}>
              {toList(v.dmCandidates).map((c, $index) => (
                <React.Fragment key={$index}>
                  <button onClick={c?.onPick} title={c?.name} onMouseEnter={c?.onHover} onMouseLeave={v.dmClearHover} className="gp-btn" style={{ "position": "relative", "aspectRatio": "1", "width": "100%", "padding": "0", "borderRadius": "12px", "background": "#fff", "overflow": "visible", "justifyContent": "center" }}>
                    {' '}
                    <img alt="" src={c?.avatarUrl} style={{ "width": "100%", "aspectRatio": "1", "height": "auto", "objectFit": "contain", "imageRendering": "pixelated", "borderRadius": "8px", "background": "#fff", "display": "block" }} />
                    {' '}
                    <span style={css(c?.dotStyle)} />
                    {' '}
                  </button>
                </React.Fragment>
              ))}
            </div>
            <div style={css(v.dmHoverStyle)}>
              <Interp v={v.dmHoverName} />
            </div>
          </>) : null}
          {v.dmWriting ? (<>
            <div style={{ "display": "flex", "alignItems": "stretch", "gap": "8px" }}>
              <div style={{ "display": "flex", "alignItems": "center", "gap": "9px", "border": "3px solid var(--ink)", "borderRadius": "12px", "padding": "8px 10px", "background": "var(--lila)", "flex": "1 1 auto", "minWidth": "0" }}>
                <img alt="" src={v.dmToAvatar} style={{ "width": "32px", "height": "32px", "imageRendering": "pixelated", "border": "3px solid var(--ink)", "borderRadius": "8px", "background": "#fff", "display": "block", "flex": "0 0 auto" }} />
                <span style={{ "fontSize": "14px", "fontWeight": "700", "flex": "1 1 auto", "overflow": "hidden", "textOverflow": "ellipsis", "whiteSpace": "nowrap" }}>
                  <Interp v={v.dmToName} />
                </span>
              </div>
              <button onClick={v.dmBackToPicker} className="gp-btn" style={{ "flex": "0 0 auto", "alignSelf": "stretch", "height": "auto", "fontSize": "13px", "padding": "0 14px", "borderRadius": "12px" }}>
                Ander
              </button>
            </div>
            <textarea value={v.dmText ?? ''} onInput={v.onDmInput} placeholder="Schrijf je bericht…" rows="4" style={{ "fontFamily": "inherit", "fontSize": "14px", "padding": "10px 12px", "border": "3px solid var(--ink)", "borderRadius": "12px", "outline": "none", "width": "100%", "boxSizing": "border-box", "resize": "vertical" }} />
            {v.hasDmError ? (<>
              <div style={{ "fontSize": "13px", "color": "var(--fout)", "fontWeight": "600" }}>
                <Interp v={v.dmError} />
              </div>
            </>) : null}
            <button onClick={v.sendDm} className="gp-btn pink" disabled={v.dmSending} style={{ "alignSelf": "flex-end" }}>
              <Interp v={v.dmSendLabel} />
            </button>
          </>) : null}
        </div>
      </div>
      {' '}
    </>
  );
}
